import React from "react";
import Verifications from "./Verifications";

export default function RestaurantVerifications() {
  return <Verifications segment="restaurant" title="Restaurant Verification" description="Review restaurant KYC documents and approve partners." />;
}
